<div class="detail-card">
  <div class="card-bar">
    <h3>{{this.heading}}</h3>
    <span class="count-pill">{{this.rows.length}}</span>
    <div class="card-bar-action">
      <ng-content></ng-content>
    </div>
  </div>

  <div class="card-empty" *ngIf="!this.rows.length">{{this.emptyText}}</div>

  <ng-container *ngIf="this.rows.length">
    <div class="card-grid">
      <ejs-grid [dataSource]="this.rows" [columns]="this.columns" [aggregates]="this.aggregates"
        [allowPaging]="this.pageSize > 0" [pageSettings]="this.pageSettings" [allowSorting]="true"
        [allowFiltering]="true" [filterSettings]="this.filterSettings" [allowTextWrap]="true" [enableHover]="true">
      </ejs-grid>
    </div>

    <div class="kw-mobile-list">
      <div class="card-row" *ngFor="let m of this.mobileRows | slice:0:mobileVisibleCount; trackBy: trackByRow">
        <div class="card-row-top">
          <span class="card-row-name">{{m.row.key}}</span>
          <span *ngIf="m.status" class="status-tag" [ngClass]="m.statusClass">
            <span class="status-dot"></span>{{m.status}}
          </span>
        </div>
        <span class="card-row-sub">{{m.detail}}</span>
      </div>

      <button class="m-show-more" *ngIf="this.mobileRows.length > mobileVisibleCount"
              mat-stroked-button (click)="showMoreMobile()">
        Show more ({{this.mobileRows.length - mobileVisibleCount}} remaining)
      </button>
    </div>
  </ng-container>
</div>
